/* eslint-disable */
import session from './session';

export default {
    getCellSizeList(filter) {
        return session.get(`cell_size/${filter}`);
    },
    getCellSize(id) {
        return session.get(`cell_size/${id}/`);
    },
    createCellSize(data) {
        return session.post(`cell_size/`, data);
    },
    updateCellSize(id, data) {
        return session.patch(`cell_size/${id}/`, data );
    },
    deleteCellSize(id) {
        return session.delete(`cell_size/${id}/`);
    },
};